import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const menuStateSelector = () =>
  createSelector(
    (state: AppState) => state.runtime.menu.isMenuOpen,
    (item) => item,
  );
